export default __webpack_public_path__ + "static/media/lb-sp.5895e4ca.webp";